// helper: update height for all matching inputs (supports multiple elements)
export function updateChatFormInputHeight(options = {}) {
    const opts = Object.assign({ reset: false, onlyIfEmpty: false }, options);

    const $inputs = jQuery('.g-chatform-footer-input-wrapper .g-chatform-text-input');
    if ($inputs.length === 0) return;

    $inputs.each(function () {
        const $el = jQuery(this);

        // store original height once
        if (typeof $el.data('origHeight') === 'undefined') {
            $el.data('origHeight', $el.height());
        }

        // Set up blur event listener for auto-reset functionality (one-time setup)
        if (!$el.data('blurListenerAttached')) {
            // On blur: start delayed reset if content doesn't change
            $el.on('blur', function () {
                clearResetTimeout($el);

                const currentContent = $el.val() || '';
                $el.data('resetCheckContent', currentContent);

                // Reset height after delay if content hasn't changed
                const timeout = setTimeout(() => {
                    const checkContent = $el.data('resetCheckContent') || '';
                    const currentVal = $el.val() || '';

                    if (checkContent === currentVal) {
                        resetToBaseline($el);
                    }
                }, 1000);

                $el.data('resetTimeout', timeout);
            });

            // On focus: cancel any pending reset
            $el.on('focus', function () {
                clearResetTimeout($el);
            });

            $el.data('blurListenerAttached', true);
        }

        if (opts.reset) {
            if (opts.onlyIfEmpty && $el.val() && $el.val().trim().length > 0) {
                updateSingle($el);
            } else {
                // Delayed reset: only reset if content doesn't change
                clearResetTimeout($el);

                const currentContent = $el.val() || '';
                $el.data('resetCheckContent', currentContent);

                const timeout = setTimeout(() => {
                    const checkContent = $el.data('resetCheckContent') || '';
                    const currentVal = $el.val() || '';

                    if (checkContent === currentVal) {
                        resetToBaseline($el);
                    }
                }, 100);

                $el.data('resetTimeout', timeout);
            }
        } else {
            updateSingle($el);
        }
    });
}

// internal helper to compute and apply height for a single element
function updateSingle($el) {
    const val = ($el.val() || '').toString();
    const element = $el[0];

    // Get CSS properties from computed style
    const computedStyle = window.getComputedStyle(element);
    const minHeight = parseInt(computedStyle.minHeight) || 45;
    const maxHeight = parseInt(computedStyle.maxHeight) || 130;

    // Store the min-height as baseline
    let baseline = $el.data('baseline');
    if (!baseline) {
        baseline = minHeight;
        $el.data('baseline', baseline);
    }

    // If input is empty, reset to baseline
    if (val.trim().length === 0) {
        const currentHeight = $el.outerHeight();
        if (Math.abs(currentHeight - baseline) > 2) {
            window.requestAnimationFrame(() => {
                $el.css('height', baseline + 'px');
            });
        }
        return;
    }

    // Temporarily reset height to baseline to get accurate scrollHeight
    // This is necessary to detect if content actually overflows
    $el.css('height', baseline + 'px');

    // Check if content overflows
    // scrollHeight includes the full content height, clientHeight is the visible height
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;

    // Calculate the new height needed
    let newHeight;

    if (scrollHeight > clientHeight) {
        // Content overflows - we need to grow
        newHeight = Math.min(scrollHeight, maxHeight);
    } else {
        // Content fits - stay at current height or baseline
        const currentOuterHeight = $el.outerHeight();

        // If we're already taller than baseline, check if we can shrink
        if (currentOuterHeight > baseline) {
            // Try the current height minus one increment to see if content still fits
            const testHeight = currentOuterHeight;
            $el.css('height', testHeight + 'px');

            if (element.scrollHeight <= element.clientHeight) {
                // Content still fits, we can stay at this height
                newHeight = testHeight;
            } else {
                // We need the current height
                newHeight = currentOuterHeight;
            }
        } else {
            newHeight = baseline;
        }
    }

    // Apply the new height
    window.requestAnimationFrame(() => {
        $el.css('height', newHeight + 'px');
    });
}

// Helper: Clear any pending reset timeout
function clearResetTimeout($el) {
    const timeout = $el.data('resetTimeout');
    if (timeout) {
        clearTimeout(timeout);
        $el.removeData('resetTimeout');
    }
}

// Helper: Reset input height to baseline
function resetToBaseline($el) {
    const baseline = $el.data('baseline');
    if (baseline) {
        window.requestAnimationFrame(() => {
            $el.css('height', baseline + 'px');
        });
    } else {
        // Fallback to origHeight if baseline not set yet
        const orig = $el.data('origHeight');
        if (typeof orig !== 'undefined') {
            window.requestAnimationFrame(() => {
                $el.css('height', orig + 'px');
            });
        }
    }
}
